<div class="tm-container">
  <div class="tm-filter">
    <div class="tm-element">
      <app-autocomplete placeholder="Editar" inputId="team-management-autocomplete" placeholder="Busca" maxLength="200"
        [height]="'36px'" [emitIndex]="true"
        [autoSearchResults]="autocompleteTeamMembers" [onlyDescription]="false" [defaultValue]="inputSearchValue"
        (ElementSelected)="searchTeamMember($event)" (autocompleteSearch)="autocompleteSearchTeamMember($event)"
        value="label" [enhanveOnHover]="false">
      </app-autocomplete>
      <button id="menu-action-options" class="btn-options" [ngClass]="{'open-modal': isOpenMenu}" [matMenuTriggerFor]="beforeMenu"
        (click)="isOpenMenu = !isOpenMenu" *ngIf="selectedTeamMembers.length >= 1">
        <span class="btn-text">Ações</span>
        <img src="../../assets/svgs/arrow_down.svg" alt="Icon">
      </button>
      <mat-menu #beforeMenu="matMenu" xPosition="before">
        <button id="edit-massive-scale" mat-menu-item (click)="editMultipleWorkSchedule()">Editar escala em massa</button>
        <button id="set-users" mat-menu-item (click)="editMultipleUsers()">Configurar usuários</button>
      </mat-menu>
    </div>
    <div class="selected-tags">
      <app-content-scrollable>
        <div #childComponent class="tags-container" class="enable-swipe"  *ngIf="tags.length">
          <app-tags [id]="'tag-chip-' + a" (remove)="removeTag(a)" class="tag" *ngFor="let tag of tags; let a = index">
            {{ tag.value }}
          </app-tags>
        </div>
      </app-content-scrollable>
    </div>
    <div class="card-template">
      <div class="ml"></div>
      <app-team-management-table [listHeaders]="listHeaders" (searchMore)="listTeamPaginated($event)"
        (sortItems)="listTeamSorted($event.sortData)" [listBinding]="listBinding" [searching]="searchingTeam"
        [sortKey]="sortedColumn"
        isHoverTable="true" (sendOptions)="sendOptions($event)" (sendItemSelections)="sendItemSelections($event)"
        (sendSelections)="sendAllSelections($event)">
      </app-team-management-table>
      <div class="mr"></div>
    </div>
  </div>
  <app-modal-work-schedule [display]="editWorkSchedule" [members]="editingScheduleMembers"
    (closeModal)="editWorkSchedule = false" *ngIf="editWorkSchedule"></app-modal-work-schedule>

  <app-modal-config-users [open]="openConfigUsers" [users]="usersToConfigure" (closeModal)="openConfigUsers = false" *ngIf="openConfigUsers">
  </app-modal-config-users>